'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var index = require('../../../_virtual/index.js_commonjs-exports2.js');
require('./components/Provider.js');
require('./components/inject.js');
require('./components/Elements.js');
require('./components/Element.js');
require('./components/PaymentRequestButtonElement.js');
var inject = require('../../../_virtual/inject.js_commonjs-exports.js');
var Elements = require('../../../_virtual/Elements.js_commonjs-exports.js');
var Element = require('../../../_virtual/Element.js_commonjs-exports.js');
var PaymentRequestButtonElement = require('../../../_virtual/PaymentRequestButtonElement.js_commonjs-exports.js');
var Provider = require('../../../_virtual/Provider.js_commonjs-exports.js');

Object.defineProperty(index.__exports, "__esModule", {
  value: true
});
index.__exports.IdealBankElement = index.__exports.IbanElement = index.__exports.PaymentRequestButtonElement = exports.PostalCodeElement = index.__exports.PostalCodeElement = exports.CardCVCElement = index.__exports.CardCVCElement = exports.CardExpiryElement = index.__exports.CardExpiryElement = exports.CardNumberElement = index.__exports.CardNumberElement = exports.CardElement = index.__exports.CardElement = exports.Elements = index.__exports.Elements = exports.injectStripe = index.__exports.injectStripe = exports.StripeProvider = index.__exports.StripeProvider = undefined;

var _Provider = Provider.__exports;

var _Provider2 = _interopRequireDefault(_Provider);

var _inject = inject.__exports;

var _inject2 = _interopRequireDefault(_inject);

var _Elements = Elements.__exports;

var _Elements2 = _interopRequireDefault(_Elements);

var _Element = Element.__exports;

var _Element2 = _interopRequireDefault(_Element);

var _PaymentRequestButtonElement = PaymentRequestButtonElement.__exports;

var _PaymentRequestButtonElement2 = _interopRequireDefault(_PaymentRequestButtonElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Define Elements, and register their implied token / source types for
// automatic token / source creation.

// Card
var CardElement = (0, _Element2.default)('card', {
  impliedTokenType: 'card',
  impliedSourceType: 'card'
});

// Split Fields
// Note: we only register the CardNumberElement for split fields so that we have
// a unique Element to infer when calling `wrappedCreateToken` or `wrappedCreateSource`.

var CardNumberElement = (0, _Element2.default)('cardNumber', {
  impliedTokenType: 'card',
  impliedSourceType: 'card'
});
var CardExpiryElement = (0, _Element2.default)('cardExpiry');
var CardCVCElement = (0, _Element2.default)('cardCvc');
var PostalCodeElement = (0, _Element2.default)('postalCode');

// IBAN
var IbanElement = (0, _Element2.default)('iban', {
  impliedTokenType: 'bank_account',
  impliedSourceType: 'sepa_debit'
});

// iDEAL Bank
var IdealBankElement = (0, _Element2.default)('idealBank', { impliedSourceType: 'ideal' });

exports.StripeProvider = index.__exports.StripeProvider = _Provider2.default;
exports.injectStripe = index.__exports.injectStripe = _inject2.default;
exports.Elements = index.__exports.Elements = _Elements2.default;
exports.CardElement = index.__exports.CardElement = CardElement;
exports.CardNumberElement = index.__exports.CardNumberElement = CardNumberElement;
exports.CardExpiryElement = index.__exports.CardExpiryElement = CardExpiryElement;
exports.CardCVCElement = index.__exports.CardCVCElement = CardCVCElement;
exports.PostalCodeElement = index.__exports.PostalCodeElement = PostalCodeElement;
index.__exports.PaymentRequestButtonElement = _PaymentRequestButtonElement2.default;
index.__exports.IbanElement = IbanElement;
index.__exports.IdealBankElement = IdealBankElement;

exports["default"] = index.__exports;
